import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import {
  isSessionExpired,
  clearRefreshTokenExpiry,
} from "../utils/sessionExpiry";
import { useAuth } from "../context/AuthContext";
import { clearAuthToken } from "../utils/tokenStorage";
import excludedRoutes from "../utils/excludeRoutes";

const SessionChecker = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setIsAuthenticated } = useAuth();

  useEffect(() => {
    if (excludedRoutes.includes(location.pathname)) return;

    if (isSessionExpired()) {
      console.warn("Session expired — logging out");
      clearAuthToken();
      clearRefreshTokenExpiry();
      setIsAuthenticated(false);
      navigate("/");
    }
  }, [location.pathname]);

  return null;
};

export default SessionChecker;
